import { render, staticRenderFns } from "./evaluate_label.vue?vue&type=template&id=b2e444a8&scoped=true"
import script from "./evaluate_label.vue?vue&type=script&lang=js"
export * from "./evaluate_label.vue?vue&type=script&lang=js"
import style0 from "./evaluate_label.vue?vue&type=style&index=0&id=b2e444a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e444a8",
  null
  
)

export default component.exports